import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'input']

  connect () {
    this.refresh()
  }

  refresh () {
    const value = this.hasInputTarget ? this.inputTarget.value : ''
    const empty = !value || value.split(',').filter(Boolean).length === 0

    this.buttonTargets.forEach((el) => {
      if (empty) {
        el.setAttribute('disabled', 'disabled')
        el.setAttribute('aria-disabled', 'true')
        el.classList.add('pointer-events-none', 'opacity-50')
      } else {
        el.removeAttribute('disabled')
        el.removeAttribute('aria-disabled')
        el.classList.remove('pointer-events-none', 'opacity-50')
      }
    })
  }
}
